export const TokenActionTypes = {
    SET_TOKEN: 'SET_TOKEN',
    IS_AUTHENTICATED: 'IS_AUTHENTICATED',
    IS_ADMIN: 'IS_ADMIN',
    USER_TYPE: 'USER_TYPE',
    SET_NO_PRICING_AVAILABLE: 'SET_NO_PRICING_AVAILABLE',
    RESET: "RESET",
    SET_UNIQUE_ID:"SET_UNIQUE_ID"
  };
  